import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { VT911 } from '@rsos/capstone/src/constants/capabilities';
import { selectUserPermissionsByApp } from '@rsos/sinatra';
import { VT911_PERMISSION } from '../constants/permissions';
import useIsVT911CoreEnabled from './useIsVT911CoreEnabled';

const useIsVT911Enabled = () => {
  // We add a check for the new video-to-911 capability in case the new
  // capability / permission is enabled, but the old capability / permission
  // is disabled.  This way we keep backwards compatibility.
  const newVT911Enabled = useIsVT911CoreEnabled();
  const user = useSelector(state => state.sinatra.user);

  const currentPSAP = useSelector(state => state.psaps.currentPSAP);

  const permissions =
    user.profile && selectUserPermissionsByApp(user, 'capstone');

  const isVT911Enabled = useMemo(() => {
    return !!(
      (currentPSAP?.activeCapabilities?.[VT911] &&
        permissions?.includes(VT911_PERMISSION)) ||
      newVT911Enabled
    );
  }, [currentPSAP, permissions, newVT911Enabled]);

  return isVT911Enabled;
};

export default useIsVT911Enabled;
